/**
 * This file contains utils specifically for the table.
 */

/*
 * Adds scroll shadow divs and an event listener to adjust shadow opacity
 * @param  {object} table The table object
 */
export function calcScrollShadow(table) {
  const { height, container } = table;

  // We want to get the last instantiated grid as a backup.
  const grids = document.querySelectorAll('.ag-datacenter');
  const gridElm = grids.length ? grids[grids.length - 1] : false;

  // If the container isn't defined, then we use the last grid.
  const parentElm = container || gridElm;

  // If neither is defined, then we want to exit out.
  if (!parentElm) {
    return;
  }
  const bodyContainer = parentElm.querySelector('.ag-body-container');
  const vp = parentElm.querySelector('.ag-body-viewport');

  // If there is any of the shadow elements present, we've already
  // initialized the shadow elements and scroll event
  if (!!parentElm.querySelector('.ag-scroll-shadow-right')) {
    parentElm.querySelector('.ag-scroll-shadow-bottom').style.opacity =
      bodyContainer.clientHeight - height <= 0 ?
        0 : 1;

    parentElm.querySelector('.ag-scroll-shadow-right').style.opacity =
      bodyContainer.clientWidth - vp.clientWidth <= 0 ?
            0 : 1;
    return;
  }

  let shadowRight = parentElm.querySelector('.ag-scroll-shadow-right');
  let shadowLeft = parentElm.querySelector('.ag-scroll-shadow-left');
  let shadowTop = parentElm.querySelector('.ag-scroll-shadow-top');
  let shadowBottom = parentElm.querySelector('.ag-scroll-shadow-bottom');
  const marginLeft =
    parentElm.querySelector('.ag-body-viewport-wrapper').style.marginLeft;

  // 10 = width/height of shadow elements in CSS
  const shadowLeftAdjust = marginLeft.replace('px', '') - 10;
  const shadowTopAdjust = -10;

  shadowTop = document.createElement('div');
  shadowTop.className = 'ag-scroll-shadow-top';
  shadowTop.style.width = bodyContainer.style.width;
  shadowTop.style['z-index'] = 9999999;
  shadowBottom = document.createElement('div');
  shadowBottom.className = 'ag-scroll-shadow-bottom';
  shadowBottom.style.width = bodyContainer.style.width;
  shadowBottom.style['z-index'] = 9999999;
  shadowRight = document.createElement('div');
  shadowRight.className = 'ag-scroll-shadow-right';
  shadowLeft = document.createElement('div');
  shadowLeft.className = 'ag-scroll-shadow-left';
  vp.appendChild(shadowTop);
  vp.appendChild(shadowBottom);
  vp.appendChild(shadowRight);
  vp.appendChild(shadowLeft);
  shadowTop.style.opacity = 0;
  shadowLeft.style.opacity = 0;

  vp.addEventListener('scroll', () => {
    shadowBottom.style.width = bodyContainer.style.width;
    shadowTop.style.width = bodyContainer.style.width;
    const scrollRight =
      bodyContainer.clientWidth - vp.clientWidth - vp.scrollLeft;
    const scrollBottom =
      bodyContainer.clientHeight - vp.clientHeight - vp.scrollTop;
    shadowRight.style.opacity = scrollRight / 20 > 1 ?
      1.0 : scrollRight / 20;
    shadowLeft.style.opacity = vp.scrollLeft / 20 > 1 ?
      1.0 : vp.scrollLeft / 20;
    shadowTop.style.opacity = vp.scrollTop / 20 > 1 ?
      1.0 : vp.scrollTop / 20;
    shadowBottom.style.opacity = scrollBottom / 20 > 1 ?
      1.0 : scrollBottom / 20;
  });

  shadowBottom.style.opacity =
    bodyContainer.clientHeight - height <= 0 ?
      0 : 1;

  shadowRight.style.opacity =
    bodyContainer.clientWidth - vp.clientWidth <= 0 ?
      0 : 1;

  shadowLeft.style.left = `${shadowLeftAdjust}px`;
  shadowTop.style.top = `${shadowTopAdjust}px`;
}



// WEBPACK FOOTER //
// ../datacenter/app/js/services/table/util.js